import * as angular from 'angular';
import * as moment from 'moment';

import { TaskProgressChart } from './taskProgress.chart';
import { DurationFormatter } from './durationFormatter';
import { ComponentDefinition, TaskResult, TaskStatus } from '../../models/index';

class TaskProgressController implements angular.IComponentController {

    private _batch: any;
    private _chart: TaskProgressChart;
    private _timer: angular.IPromise<any>;

    isLoading: boolean;
    onClick: (d, i) => void;
    data: TaskResult;

    static $inject = ['$state', '$translate', '$interval'];

    constructor(
        private _$state: angular.ui.IStateService,
        private _$translate: angular.translate.ITranslateService,
        private _$interval: angular.IIntervalService
    ) {
        this._chart = new TaskProgressChart('.task-progress')
            .labelClick((d, i) => {
                const beginDate = d.value[0].range.beginDateTime;
                const endDate = d.value[d.value.length - 1].range.endDateTime;
                return this._$state.go('group.resultsStatus', { groupGuid: d.key.guid, beginDate: beginDate, endDate: endDate });
            })
            .tooltipFormat(sr => {
                return `${DurationFormatter.formatDuration(moment.duration(sr.elapsed))} ${this._$translate.instant(sr.stepName)}`;
            });
    }

    $onInit() {
        this._chart.batchClick((d, i) => {
            this._batch = d;
            this.onClick({ batch: d }, i);
        }).selectFirst();
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['data'] && changesObj['data'].currentValue) {
            this._chart.update(changesObj['data'].currentValue.batchResults);
            if (!this._batch) {
                this._chart.selectFirst();
            }
            this.startTimer();
        }
    }

    private startTimer() {
        this.stopTimer();
        this._timer = this._$interval(() => {
            const batches = this.data.batchResults
                .map(b => b.value)
                .reduce((a, b) => a.concat(b))
                .filter(b => b.exitCode === TaskStatus.Started);

            if (batches.length === 0) {
                this.stopTimer();
            }
            else {
                const runningSteps = batches
                    .map(b => b.stepResults)
                    .reduce((a, b) => a.concat(b))
                    .filter(s => s.exitCode === TaskStatus.Started);

                runningSteps.forEach(s => {
                    s.elapsed = moment.duration(s.elapsed).add(1, 'seconds').toISOString();
                });
                this._chart.update(this.data.batchResults);
            }
        }, 1000);
    }

    private stopTimer() {
        if (this._timer) {
            this._$interval.cancel(this._timer);
        }
    }
}

export const wtTaskProgress: ComponentDefinition = {
    componentId: 'wtTaskProgress',
    controller: TaskProgressController,
    template: require('./taskProgress.component.html'),
    controllerAs: 'vm',
    bindings: {
        data: '<',
        isLoading: '<',
        onClick: '&?'
    }
};